/**
 * Dealers List Route - React Router v7
 *
 * Route: /concesionarios/*
 * Description: Professional dealers listing with filters (province, make, city)
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {redirect, useLoaderData} from 'react-router-dom'

import {withRouter} from '../../hocs/withRouter'
import {getInitialProps} from './getInitialProps.js'
import DealersList from './index.js'

// Import styles
import './styles/index.scss'

const DealersListWithRouter = withRouter(DealersList)

/**
 * Loader for Dealers List page
 * Fetches dealer search results with filters
 */
export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const search = url.search
  const queryParams = Object.fromEntries(url.searchParams)

  const routeInfo = {
    location: {
      pathname,
      query: queryParams,
      search
    }
  }

  try {
    const initialProps = await getInitialProps({
      routeInfo,
      context
    })

    // Handle redirects
    if (initialProps.__HTTP__?.redirectTo) {
      return redirect(initialProps.__HTTP__.redirectTo)
    }

    return {
      ...initialProps,
      __RR7__: true
    }
  } catch (error: unknown) {
    console.error('[RR7] DealersList loader error:', error)
    throw error
  }
}

/**
 * Component wrapper for RR7
 */
export function Component() {
  const data = useLoaderData()

  return <DealersListWithRouter {...data} />
}

Component.displayName = 'DealersListRoute'
